// MenteeQuestionsSelector.tsx

import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntityMeetingQuestions } from 'app/entities/question/question.reducer';

const MenteeQuestionsSelector = ({ userId, onChange, onchangeError }) => {
  const dispatch = useAppDispatch();
  const questions = useAppSelector(state => state.question.entity);

  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (userId) {
      dispatch(getEntityMeetingQuestions(userId));
    }
  }, [userId]);

  const handleToggle = questionId => {
    let updated;

    if (selected.includes(questionId)) {
      updated = selected.filter(id => id !== questionId);
    } else {
      updated = [...selected, questionId];
    }

    setSelected(updated);
    onChange(updated); // send to parent
    onchangeError('');
  };

  if (!questions?.length) return null;

  return (
    <div className="mt-3">
      <h5>
        Select Questions for Meeting <span className="text-danger">*</span>
      </h5>

      {questions.map(q => (
        <div key={q.questionId} className="d-flex align-items-start gap-2 mb-2">
          <input type="checkbox" className="mt-1" checked={selected.includes(q.questionId)} onChange={() => handleToggle(q.questionId)} />
          <label className="mb-0">{q.question}</label>
        </div>
      ))}
    </div>
  );
};

export default MenteeQuestionsSelector;
